export const DEFAULT_ENTRY_FEE = 0

export const normalizeOptional = (value?: string | null) => {
  if (!value) return undefined
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : undefined
}

export const RECENT_EVENTS_STORAGE_KEY = 'honeyshow/check-in/recent-events/collapsed'

export const parseCheckInTimestamp = (value?: string | null): number => {
  if (!value) return 0
  const parsed = Date.parse(value)
  return Number.isNaN(parsed) ? 0 : parsed
}

export const formatCheckInTimestamp = (value?: string | null): string => {
  if (!value) return ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  const now = new Date()
  const sameDay =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate()
  const timeFormatter = new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' })
  if (sameDay) {
    return timeFormatter.format(date)
  }
  const dateFormatter = new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
  })
  return `${dateFormatter.format(date)} · ${timeFormatter.format(date)}`
}
